import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'cutString',
  standalone: true,
})
export class CutStringPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) {
      return '';
    }

    if (value?.length <= 10) {
      return value;
    }

    const firstPart = value?.slice(0, 6);
    const lastPart = value?.slice(-6);
    const maskedPart = '...';

    return `${firstPart}${maskedPart}${lastPart}`;
  }
}
